module.exports = __webpack_public_path__ + "img/skale-light.319977e5.svg";